import { ProjectListToolbar } from "../../project-list"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import { ProjectSortSelector } from "./project-sort-selector"

ProjectListToolbar("left").plug(<SearchBoxUsingSearchParam placeholder="Search" />)
ProjectListToolbar("right").plug(<ProjectSortSelector />)
